import { Slider, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import { getValueLabelFormat } from '../utils/formatter';

const useStyles = makeStyles((theme) => ({
  relativePaddingSection: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    width: 'auto',
    marginLeft: theme.spacing(2),
  },
  relativePaddingLabel: {
    whiteSpace: 'nowrap',
  },
  sliderWrapper: {
    width: 200,
  },
  paddingBadge: {
    backgroundColor: theme.palette.grey[400],
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.shape.borderRadius,
    fontSize: '0.75rem',
    fontWeight: 500,
    minWidth: 60,
    textAlign: 'center',
  },
}));

const RelativePaddingSlider = ({ mappingParam, paramConfig, onPaddingChange, disabled, configSwitchLabel, param='shape' }) => {
  const classes = useStyles();
  const [padding, setPadding] = useState(undefined);

  useEffect(() => {
      const enabledChildren = mappingParam?.children.filter((entity) => entity.checked);
      if (!enabledChildren.length) {
        setPadding(0);
      } else {
        let maxPadding = 0;
        // Get max padding from all enabled sizes and their enabled shanks
        if(param === 'shape') {
          maxPadding = Math.max(
            ...enabledChildren.flatMap((size) => {
              const sizeConfig = paramConfig?.sizes.find((s) => s.size_sku === size?.sku);
              const enabledShanks = size.children.filter(shank => shank.checked);
              return enabledShanks.map(shank => {
                const shankConfig = sizeConfig?.shanks.find(s => s.shank_sku === shank.sku);
                return shankConfig?.config[configSwitchLabel].padding || 0;
              });
            })
          );
        }else {
          maxPadding = Math.max(
            ...enabledChildren.flatMap((width) => {
              const widthConfig = paramConfig?.[width.sku_code]?.config[configSwitchLabel];
              return widthConfig?.padding || 0;
            })
          );
        }
        setPadding(maxPadding);
      }
  }, [mappingParam, paramConfig, padding, configSwitchLabel]);

  const handleChange = (_, newValue, event) => {
    event?.stopPropagation();
    const id = param === 'shape' ? mappingParam?.id : mappingParam?.sku_code;
    const difference = newValue - padding;
    onPaddingChange(id, difference, event);
    setPadding(newValue);
  };

  return (
    <div className={classes.relativePaddingSection} onClick={(e) => e?.stopPropagation()}>
      <Typography variant="body2" className={classes.relativePaddingLabel}>
        Relative Padding
      </Typography>
      <div className={classes.sliderWrapper}>
        <Slider
          value={padding || 0}
          onChange={handleChange}
          min={0}
          max={50}
          step={1}
          disabled={disabled}
          valueLabelDisplay="auto"
          valueLabelFormat={getValueLabelFormat}
        />
      </div>
      <Typography variant="body2" className={classes.paddingBadge}>
        {getValueLabelFormat(padding)}
      </Typography>
    </div>
  );
};

export default RelativePaddingSlider;
